import { useEffect, useState } from "react";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  if (isNaN(t) || t <= 0) return null;
  return {
    d: Math.floor(t / 86400000),
    h: Math.floor((t % 86400000) / 3600000),
    m: Math.floor((t % 3600000) / 60000),
    s: Math.floor((t % 60000) / 1000),
  };
}

export default function Countdown({ target, onDone, light }) {
  const [left, setLeft] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => {
      const d = diff(target);
      setLeft(d);
      if (!d && onDone) onDone();
    }, 1000);
    return () => clearInterval(id);
  }, [target, onDone]);

  if (!left) return null;
  const cell = (v, l) => (
    <div className="flex flex-col items-center">
      <span className={`font-display text-3xl sm:text-5xl leading-none ${light ? "text-white" : "text-white"}`}>
        {String(v).padStart(2, "0")}
      </span>
      <span className="text-[10px] uppercase tracking-widest text-zinc-400 mt-1">{l}</span>
    </div>
  );
  return (
    <div className="flex gap-4 sm:gap-6 items-start" data-testid="countdown">
      {cell(left.d, "Days")}<span className="text-accent font-display text-3xl sm:text-5xl">:</span>
      {cell(left.h, "Hrs")}<span className="text-accent font-display text-3xl sm:text-5xl">:</span>
      {cell(left.m, "Min")}<span className="text-accent font-display text-3xl sm:text-5xl">:</span>
      {cell(left.s, "Sec")}
    </div>
  );
}
